(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class VrProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.syncFromDom(); return; }
      this.ready = true;
      this.product = JSON.parse(this.querySelector('[data-product-json]').textContent);
      this.offer = this.dataset.offer === 'true';
      this.pct = { 2: Number(this.dataset.pct2 || 0), 3: Number(this.dataset.pct3 || 0) };
      this.currency = this.dataset.currency || 'USD';
      this.qty = 1;
      var urlVariant = new URLSearchParams(window.location.search).get('variant');
      this.variant = this.product.variants.find(function (v) { return String(v.id) === urlVariant; }) ||
        this.product.variants.find(function (v) { return v.available; }) || this.product.variants[0];
      this.fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.currency });
      this.initGallery();
      this.initOptions();
      this.initOffer();
      this.initBuy();
      this.initSticky();
      this.initStock();
      var startMedia = urlVariant && this.variant.featured_media ? this.querySelector('[data-media-id="' + this.variant.featured_media.id + '"]') : null;
      var slidesEl = this.querySelector('[data-slides]');
      if (startMedia && slidesEl) slidesEl.scrollLeft = startMedia.offsetLeft;
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) this.syncFromDom();
      }.bind(this));
    }

    syncFromDom() {
      var qtyInput = this.querySelector('[data-qtybox] input');
      if (qtyInput && !this.offer) this.qty = Math.min(20, Math.max(1, Number(qtyInput.value) || 1));
      var opts = this.querySelectorAll('[data-options] input:checked');
      if (opts.length && this.product && this.product.variants) {
        var picked = Array.prototype.map.call(opts, function (i) { return i.value; });
        var match = this.product.variants.find(function (v) { return picked.every(function (val, n) { return v.options[n] === val; }); });
        if (match) this.variant = match;
      }
      if (this.offer) {
        var row = this.querySelector('.vrp__row input:checked');
        this.qty = row ? Math.min(3, Math.max(1, Number(row.value) || 1)) : 1;
        this.units.forEach(function (u) { u.hidden = Number(u.dataset.unit) > this.qty; }.bind(this));
      }
      this.renderBuy();
    }

    money(cents) { return this.fmt.format(cents / 100); }

    initGallery() {
      var slides = this.querySelector('[data-slides]');
      if (!slides) return;
      var self = this;
      var items = slides.querySelectorAll('.vrp__slide');
      var thumbs = this.querySelectorAll('[data-thumb]');
      var thumbBox = this.querySelector('[data-thumbs]');
      var counter = this.querySelector('[data-counter]');
      var total = items.length;
      var current = function () { return Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)); };
      var goIndex = function (i) {
        if (!total) return;
        var n = (i % total + total) % total;
        slides.scrollTo({ left: items[n].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      };
      this.goTo = function (id) {
        var target = slides.querySelector('[data-media-id="' + id + '"]');
        if (target) slides.scrollTo({ left: target.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      };
      var syncThumbs = function (i) {
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === i);
          if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        if (counter) counter.textContent = (i + 1) + ' / ' + total;
        var active = thumbs[i];
        if (thumbBox && active) {
          var left = active.offsetLeft - (thumbBox.clientWidth - active.offsetWidth) / 2;
          thumbBox.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
        }
      };
      var stable = 0;
      var resizing = false;
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          resizing = true;
          slides.scrollTo({ left: stable * slides.clientWidth, behavior: 'auto' });
          clearTimeout(self.resizeTimer);
          self.resizeTimer = setTimeout(function () { resizing = false; }, 200);
        }).observe(slides);
      }
      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goIndex(n); }); });
      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { goIndex(current() - 1); });
      if (next) next.addEventListener('click', function () { goIndex(current() + 1); });
      var lastIndex = -1;
      slides.addEventListener('scroll', function () {
        if (resizing) return;
        var i = current();
        stable = i;
        if (i === lastIndex) return;
        lastIndex = i;
        syncThumbs(i);
      }, { passive: true });
      if (window.VRWrapSwipe) window.VRWrapSwipe(slides, current, function () { return total; }, goIndex);
      items.forEach(function (it) { it.setAttribute('tabindex', '0'); it.setAttribute('role', 'button'); });
      slides.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('vrp__slide')) { e.preventDefault(); e.target.click(); }
      });
      var videos = slides.querySelectorAll('.vrp__slide[data-video] video');
      var setPlaying = function (v, on) {
        var slide = v.closest('.vrp__slide');
        if (on) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else v.pause();
        if (slide) slide.classList.toggle('is-playing', on && !v.paused);
      };
      var labelVideo = function (v) {
        var slide = v.closest('.vrp__slide');
        if (!slide) return;
        if (!slide.dataset.baseLabel) slide.dataset.baseLabel = slide.getAttribute('aria-label') || 'Product video';
        slide.setAttribute('aria-label', slide.dataset.baseLabel + (v.paused ? ': play video' : ': pause video'));
        slide.setAttribute('aria-pressed', v.paused ? 'false' : 'true');
      };
      videos.forEach(function (v) {
        labelVideo(v);
        v.addEventListener('play', function () { v.closest('.vrp__slide').classList.add('is-playing'); labelVideo(v); });
        v.addEventListener('pause', function () { v.closest('.vrp__slide').classList.remove('is-playing'); labelVideo(v); });
      });
      if (videos.length) {
        var pauseAll = function () { videos.forEach(function (v) { v.pause(); }); };
        document.addEventListener('visibilitychange', function () { if (document.hidden) pauseAll(); });
        if ('IntersectionObserver' in window) {
          var inGallery = true;
          new IntersectionObserver(function (entries) {
            inGallery = entries[0].isIntersecting;
            if (!inGallery) pauseAll();
          }, { threshold: 0.2 }).observe(slides);
          var vio = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              var visible = en.isIntersecting && en.intersectionRatio >= 0.6 && !document.hidden && inGallery;
              if (!visible) { en.target.pause(); return; }
              if (!reduce) setPlaying(en.target, true);
            });
          }, { root: slides, threshold: [0, 0.6] });
          videos.forEach(function (v) { vio.observe(v); });
        }
      }
      slides.addEventListener('click', function (e) {
        var slide = e.target.closest('.vrp__slide');
        if (!slide) return;
        if (slide.hasAttribute('data-video')) {
          var vid = slide.querySelector('video');
          if (vid) setPlaying(vid, vid.paused);
          return;
        }
        if (!window.VRLightbox) return;
        var imgSlides = Array.prototype.filter.call(items, function (it) { return !it.hasAttribute('data-video'); });
        var list = imgSlides.map(function (it) {
          var img = it.querySelector('img');
          return { src: it.getAttribute('data-full') || (img ? img.currentSrc : ''), alt: img ? img.alt : '' };
        });
        window.VRLightbox.open(list, imgSlides.indexOf(slide), slide);
      });
      var tPrev = this.querySelector('[data-tprev]');
      var tNext = this.querySelector('[data-tnext]');
      if (thumbBox) {
        var stepBy = function (dir) { thumbBox.scrollBy({ left: dir * thumbBox.clientWidth * 0.75, behavior: reduce ? 'auto' : 'smooth' }); };
        var edge = function () {
          var max = thumbBox.scrollWidth - thumbBox.clientWidth - 2;
          if (tPrev) tPrev.hidden = thumbBox.scrollLeft <= 2;
          if (tNext) tNext.hidden = thumbBox.scrollLeft >= max;
        };
        if (tPrev) tPrev.addEventListener('click', function () { stepBy(-1); });
        if (tNext) tNext.addEventListener('click', function () { stepBy(1); });
        thumbBox.addEventListener('scroll', edge, { passive: true });
        window.addEventListener('resize', edge);
        edge();
      }
      syncThumbs(0);
      this.items = items;
    }

    initOptions() {
      var self = this;
      var box = this.querySelector('[data-options]');
      if (box) {
        var read = function () {
          var chosen = [];
          box.querySelectorAll('.vrp__option').forEach(function (fs) {
            var r = fs.querySelector('input:checked');
            chosen.push(r ? r.value : null);
          });
          return self.product.variants.find(function (v) {
            return v.options.every(function (o, i) { return o === chosen[i]; });
          });
        };
        box.addEventListener('change', function () {
          var m = read();
          self.missing = !m;
          if (m) self.setVariant(m);
          else self.renderBuy();
        });
        var first = read();
        if (first) this.variant = first;
        else this.missing = true;
      }
      this.fixReviewLink();
      this.renderBuy();
    }

    fixReviewLink() {
      var link = this.querySelector('.vrp__stars');
      if (!link || document.getElementById('vr-reviews')) return;
      var target = document.querySelector('[id^="shopify-section-"][id$="__judgeme"]');
      if (target) link.setAttribute('href', '#' + target.id);
      else link.removeAttribute('href');
    }

    setVariant(v) {
      this.variant = v;
      this.missing = false;
      var price = this.querySelector('[data-price]');
      var was = this.querySelector('[data-compare]');
      var save = this.querySelector('[data-save]');
      if (price) price.textContent = this.money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (was) { was.hidden = !onSale; if (onSale) was.textContent = this.money(v.compare_at_price); }
      if (save) save.hidden = !onSale;
      var sp = this.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = this.money(v.price);
      if (v.featured_media && this.goTo) this.goTo(v.featured_media.id);
      this.renderBuy();
      this.renderStock();
      this.updateUrl();
    }

    initStock() {
      var el = this.querySelector('[data-vr-stock]');
      if (!el) return;
      var self = this;
      this.renderStock();
      this.refreshStock();
      setInterval(function () { if (!document.hidden) self.refreshStock(); }, 60000);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) self.refreshStock(); });
    }

    renderStock() {
      var el = this.querySelector('[data-vr-stock]');
      if (!el || !this.variant) return;
      var s = this.variant.stock;
      var max = Number(el.dataset.max);
      var show = s > 0 && s <= max;
      el.hidden = !show;
      if (!show) return;
      var level = s <= Number(el.dataset.low) ? 'low' : s <= Number(el.dataset.mid) ? 'mid' : 'high';
      el.classList.remove('vr-stock--low', 'vr-stock--mid', 'vr-stock--high');
      el.classList.add('vr-stock--' + level);
      el.querySelector('[data-stock-text]').textContent = el.dataset.text.replace('[n]', s);
      el.style.setProperty('--vr-stock-fill', Math.min(100, Math.round(s * 100 / max)) + '%');
    }

    refreshStock() {
      var el = this.querySelector('[data-vr-stock]');
      if (!el || !el.dataset.section || this.stockBusy) return;
      var self = this;
      this.stockBusy = true;
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(el.dataset.section), { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html.match(/<script type="application\/json" data-product-json>([\s\S]*?)<\/script>/);
          if (!m) return;
          var fresh = JSON.parse(m[1]);
          fresh.variants.forEach(function (fv) {
            var v = self.product.variants.find(function (x) { return x.id === fv.id; });
            if (v) v.stock = fv.stock;
          });
          self.renderStock();
        })
        .catch(function () {})
        .then(function () { self.stockBusy = false; });
    }

    updateUrl() {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', this.variant.id);
        history.replaceState(null, '', u.toString());
      } catch (e) {}
    }

    pickedVariants() {
      if (!this.offer) return [this.variant];
      var list = [];
      var units = this.querySelectorAll('[data-unit]');
      for (var i = 0; i < this.qty; i += 1) {
        var picked = units[i] ? units[i].querySelector('input:checked') : null;
        var v = picked ? this.product.variants.find(function (x) { return String(x.id) === picked.value; }) : this.variant;
        if (v) list.push(v);
      }
      return list.length ? list : [this.variant];
    }

    totalFor() {
      var list = this.pickedVariants();
      var n = list.length;
      var pct = n >= 3 && this.pct[3] ? this.pct[3] : n === 2 ? this.pct[2] : 0;
      return list.reduce(function (sum, v) { return sum + v.price - Math.floor(v.price * pct / 100); }, 0);
    }

    renderBuy() {
      var main = this.querySelector('[data-atc]');
      if (!main) return;
      var sticky = this.querySelector('[data-sticky-atc]');
      var label = this.querySelector('[data-atc-label]');
      if (!this.originalLabel && label) this.originalLabel = main.dataset.label || label.textContent;
      var ok = !this.missing && this.pickedVariants().every(function (v) { return v.available; });
      main.disabled = !ok;
      if (sticky) sticky.disabled = !ok;
      if (!label) return;
      if (this.missing) label.textContent = main.dataset.unavailable || label.textContent;
      else if (!ok) label.textContent = main.dataset.soldout || label.textContent;
      else label.textContent = this.originalLabel + (this.offer ? ' · ' + this.money(this.totalFor()) : '');
    }

    initOffer() {
      if (!this.offer) return;
      var self = this;
      this.radios = this.querySelectorAll('[data-offer-box] .vrp__row input[type=radio]');
      this.units = this.querySelectorAll('[data-unit]');
      this.radios.forEach(function (r) {
        r.addEventListener('change', function () {
          self.qty = Math.min(3, Math.max(1, Number(r.value) || 1));
          self.units.forEach(function (u) { u.hidden = Number(u.dataset.unit) > self.qty; });
          self.renderBuy();
        });
        if (r.checked) {
          self.qty = Math.min(3, Math.max(1, Number(r.value) || 1));
          self.units.forEach(function (u) { u.hidden = Number(u.dataset.unit) > self.qty; });
        }
      });
      this.querySelectorAll('.vrp__swatch input').forEach(function (r) {
        r.addEventListener('change', function () {
          var v = self.product.variants.find(function (x) { return String(x.id) === r.value; });
          if (!v) return;
          var unit = r.closest('[data-unit]');
          var picked = unit && unit.querySelector('[data-picked]');
          if (picked) picked.textContent = r.dataset.title || v.title || '';
          if (unit && unit.dataset.unit === '1') self.variant = v;
          if (v.featured_media && self.goTo) self.goTo(v.featured_media.id);
          self.renderBuy();
        });
      });
      this.renderBuy();
    }

    selectedItems() {
      var counts = {};
      this.pickedVariants().forEach(function (v) { counts[String(v.id)] = (counts[String(v.id)] || 0) + 1; });
      if (!this.offer) { counts = {}; counts[String(this.variant.id)] = this.qty; }
      return Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
    }

    initBuy() {
      var self = this;
      var qtyInput = this.querySelector('[data-qty]');
      var minus = this.querySelector('[data-minus]');
      var plus = this.querySelector('[data-plus]');
      var setQty = function (n) {
        self.qty = Math.min(20, Math.max(1, Math.floor(Number(n) || 1)));
        if (qtyInput) qtyInput.value = self.qty;
      };
      if (qtyInput && !this.offer) {
        qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });
        if (minus) minus.addEventListener('click', function () { setQty(self.qty - 1); });
        if (plus) plus.addEventListener('click', function () { setQty(self.qty + 1); });
      }
      var btn = this.querySelector('[data-atc]');
      if (btn) btn.addEventListener('click', this.addToCart.bind(this));
      var sticky = this.querySelector('[data-sticky-atc]');
      if (sticky) sticky.addEventListener('click', this.addToCart.bind(this));
    }

    async addToCart() {
      var btn = this.querySelector('[data-atc]');
      var err = this.querySelector('[data-error]');
      if (!btn || btn.getAttribute('aria-disabled') === 'true' || btn.disabled) return;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      if (err) err.hidden = true;
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 20000);
      var added = false;
      var useDrawerFlag = false;
      try {
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var useDrawer = !!cart && cart.tagName === 'CART-DRAWER' && typeof cart.getSectionsToRender === 'function';
        useDrawerFlag = useDrawer;
        var body = { items: this.selectedItems() };
        if (useDrawer) {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        }
        await window.VRCart.run(async function () {
          var res = await fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
            signal: controller.signal
          });
          var data = await res.json();
          if (data.status) throw new Error(data.description || data.message);
          added = true;
          if (useDrawer) {
            try { window.VRCart.render(cart, data); } catch (e) { window.location = window.routes.cart_url; }
          } else {
            window.location = window.routes.cart_url;
          }
        });
      } catch (e) {
        if (!added) {
          if (err) { err.textContent = e.message; err.hidden = false; }
          if (useDrawerFlag && window.VRCartRefresh) window.VRCartRefresh(document.querySelector('cart-drawer'));
        }
      } finally {
        clearTimeout(timer);
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      }
    }

    initSticky() {
      var bar = this.querySelector('[data-sticky]');
      var buy = this.querySelector('[data-buy]');
      if (!bar || !buy || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        var above = entries[0].boundingClientRect.top < 0;
        bar.hidden = visible || !above;
      }, { threshold: 0 }).observe(buy);
    }
  }

  if (!customElements.get('vr-product')) customElements.define('vr-product', VrProduct);
})();
